import { createContext } from 'react';
const defaultModalContext = {
    closeAllModals: () => { },
    closeModal: () => { },
    isModalOpen: () => false,
    openModal: () => { },
    updateModal: () => { },
};
export const ModalContext = createContext(defaultModalContext);
